import React, { useEffect, useState } from "react";
import { colors } from "../configs";
import '../App.css';
import { useDispatch, useSelector } from "react-redux";
import { minusDays, NumberYMD, plusDays, stringYMDHMS3 } from "../Utility/dateTime";
import { fetchBill, updateBills, updateEndDate, updateStartDate } from "../redux/billSlice";
import { Modal_Progress } from "../modal";
import TimeContainer from "./TimeContainer";


const { white } = colors;
const cutOff = new Date(2011, 0, 1, 0, 0, 0, 0);

function TimeControl() {
    const dispatch = useDispatch()
    const { shop: { shopId } } = useSelector((state)=> state.shop);

    const { billDates, modal_Bill, startDate, endDate } = useSelector((state)=> state.bill);
    const [progress, setProgress] = useState(0);

    
      useEffect(()=>{
        if(billDates.length===0){
            search()
        }
      },[])
    
    function search(){
        let rewSearch = []
        let newSearch = []
        let start = minusDays(startDate,1)

        do {
            rewSearch.push(stringYMDHMS3(start))
            start = plusDays(start,1)
        }
        while (NumberYMD(start) < NumberYMD(plusDays(endDate,2)));
        for(const item of rewSearch){
            if(!billDates.includes(item)){
                newSearch.push(item)
            }
        }
        if(newSearch.length >0){
            setProgress(0)
            dispatch(fetchBill({
            shopId,
            billDate:newSearch,
            cutOff,
            startDate,
            endDate,
            callBack:(value)=>{
                setProgress(value)
            }
            }))
        } else {
            dispatch(updateBills({startDate,endDate,cutOff}))
        }
    }

  return <React.Fragment>
            <Modal_Progress show={modal_Bill} progress={progress} /> 
            <TimeContainer
                search={search}
                show={modal_Bill}
                startDate={startDate}
                endDate={endDate}
                onChangeStart={(date) => dispatch(updateStartDate(date))}
                onChangeEnd={(date) => dispatch(updateEndDate(date))}
            /> 
        </React.Fragment>
};

const styles = {
    container : {
        borderRadius:20
    },
    container2 : {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems:'center',
        marginTop:10,
        marginBottom:10,
        paddingBottom:10
    },
    container3 : {
        display:'flex',padding:5,borderRadius:10,border: '1px solid grey',backgroundColor:white,alignItems:'center'
    },
    container4 : {
        paddingLeft:10,paddingRight:10
    },
    container5 : {
        display:'flex',padding:5,borderRadius:10,border: '1px solid grey',backgroundColor:white,marginLeft:20,alignItems:'center'
    }
}

export default TimeControl;
